import { type ApplicationConfig, provideBrowserGlobalErrorListeners } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import {
  AUTH_API_URL,
  authInterceptor,
  provideLoginFlowMessages,
  provideLoginRoutePolicy,
} from "@my-sport-app/domain";

import { routes } from "./app.routes";
import { environment } from "../environments/environment";

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    { provide: AUTH_API_URL, useValue: environment.apiUrl },
    provideLoginRoutePolicy({
      loginRoute: "/auth/business-owner",
      businessOwnerRoute: "/business-owner-dashboard",
      defaultRoute: "/business-owner-dashboard",
      accessDeniedRoute: "/auth/business-owner",
    }),
    provideLoginFlowMessages({
      businessOwnerAccessDenied: "Tu cuenta no tiene permisos de business owner.",
    }),
  ],
};
